import type {
  EntradaAlterarSenha,
  EntradaLogin,
  EntradaRecuperarSenha,
  EntradaRedefinirSenha,
  RespostaEu,
  RespostaLogin,
  RespostaNeutra,
  SessaoResumo,
} from '@baiocchi/shared'

import { api, definirTokenAcesso } from './cliente'

/**
 * `/auth` (`03-endpoints-draft.md §1`).
 *
 * Não existe função de auto-cadastro aqui, e não é esquecimento: a API não tem a
 * rota (RNF-18). Usuário nasce em `POST /usuarios`, com convite.
 */
export const autenticacaoApi = {
  async login(entrada: EntradaLogin): Promise<RespostaLogin> {
    const resposta = await api.publico<RespostaLogin>('/auth/login', entrada)
    definirTokenAcesso(resposta.tokenAcesso)
    return resposta
  },

  /** Restaura a sessão na abertura da aba. `null` = não há cookie válido. */
  restaurar(): Promise<RespostaLogin | null> {
    return api.restaurarSessao()
  },

  eu(): Promise<RespostaEu> {
    return api.get<RespostaEu>('/auth/eu')
  },

  async sair(): Promise<void> {
    try {
      await api.post<void>('/auth/logout')
    } finally {
      // Mesmo com falha de rede o token sai da memória: deixar o usuário na tela
      // logado depois de clicar em "Sair" é pior do que uma sessão órfã no
      // servidor, que o job de limpeza recolhe.
      definirTokenAcesso(null)
    }
  },

  async sairDeTodos(): Promise<{ sessoesEncerradas: number }> {
    try {
      return await api.post<{ sessoesEncerradas: number }>('/auth/logout-todos')
    } finally {
      definirTokenAcesso(null)
    }
  },

  sessoes(): Promise<SessaoResumo[]> {
    return api.get<SessaoResumo[]>('/auth/sessoes')
  },

  /** Resposta neutra por contrato: idêntica exista ou não o e-mail (RN-04). */
  recuperarSenha(entrada: EntradaRecuperarSenha): Promise<RespostaNeutra> {
    return api.publico<RespostaNeutra>('/auth/recuperar-senha', entrada)
  },

  /** Consome token de `RECUPERACAO` ou de `CONVITE` — o mesmo endpoint. */
  redefinirSenha(entrada: EntradaRedefinirSenha): Promise<RespostaNeutra> {
    return api.publico<RespostaNeutra>('/auth/redefinir-senha', entrada)
  },

  /**
   * Troca da própria senha (TELA-24). Devolve par de tokens novo porque a API
   * revoga **todas** as sessões, inclusive a que fez a chamada (RNF-17).
   */
  async alterarSenha(entrada: EntradaAlterarSenha): Promise<RespostaLogin> {
    const resposta = await api.post<RespostaLogin>('/auth/alterar-senha', entrada)
    definirTokenAcesso(resposta.tokenAcesso)
    return resposta
  },
}
